// authReducer.js

import {
  REGISTER_SUCCESS,
  REGISTER_FAILURE,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  FETCH_PENDING_REQUESTS_SUCCESS,
  FETCH_PENDING_REQUESTS_FAILURE,
  ENROLL_SUCCESS,
  ENROLL_FAILURE,
} from './authTypes';

const storedUser = (() => {
  try { return JSON.parse(localStorage.getItem("user")) || null; }
  catch { return null; }
})();

const initialState = {
  pendingRequests: [],
  user: storedUser,
  email: localStorage.getItem("email") || null,
  error: null,
  token: localStorage.getItem("token") || null,
  isAuthenticated: !!localStorage.getItem("token"),
  enrolledUsers: [],
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case REGISTER_SUCCESS:
    case LOGIN_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload,
        email: action.payload.email || null, // Safely access email
        error: null,
      };

    case REGISTER_FAILURE:
    case LOGIN_FAILURE:
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        email: null,
        error: action.payload,
      };

    case LOGOUT:
      localStorage.removeItem("token");
      localStorage.removeItem("email");
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        email: null,
        token: null,
        error: null,
      };

    case FETCH_PENDING_REQUESTS_SUCCESS:
      return {
        ...state,
        pendingRequests: action.payload,
        error: null,
      };

    case FETCH_PENDING_REQUESTS_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    case ENROLL_SUCCESS:
      return {
        ...state,
        enrolledUsers: [...state.enrolledUsers, action.payload],
        error: null,
      };

    case ENROLL_FAILURE:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default authReducer;
